<template>
  <div class="d-flex-column justify-start align-start gap-5">
    <div class="d-flex-row justify-start gap-5">
      <label for="" class="t-light regular-l font-family-2">
        {{ $t("forms.role") }}
      </label>
      <ItemTooltip :text="$t('select_desired_role')" />
    </div>
    <DropDown
      :placeholder="$t('forms.role')"
      :drop-items="getKeyedPlatforms"
      :select-drop-item="selectPlatform"
      :selected-item="checkoutStore.getSelectedRole"
      img="role"
    />
  </div>
</template>
<script setup>
import DropDown from "~/components/custom/DropDown.vue";
import ItemTooltip from "../../fc-25/pickers/ItemTooltip.vue";
const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();
const getKeyedPlatforms = computed(() => {
  return gameStore.getGame?.roles?.reduce((accumulator, value) => {
    return { ...accumulator, [value.id]: value.title };
  }, {});
});

const selectPlatform = (key, value) => {
  if (checkoutStore.getSelectedRole == value) {
    checkoutStore.setRole(null);
  } else {
    checkoutStore.setRole(parseInt(value));
  }
};
</script>
